import _cloneDeep from 'lodash/cloneDeep';

import createAppDialogController from './dialog/create-app/create-app.controller';

const createAppTemplate = require('./dialog/create-app/create-app.html');

export default class ApiAccessController {
    /** @ngInject */
    constructor(Loader, DialogService, DeveloperApi, ToastService, $timeout) {
        this.Loader = Loader;
        this.ToastService = ToastService;
        this.DialogService = DialogService;
        this.DeveloperApi = DeveloperApi;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.developer = {
            access: false,
            key: 'zx89jiaojd9--as988d8as7d8hjak',
            apps: []
        };

        this.acceptTerms = false;
        this.processing = false;
        this.currentApp = null;
        this.showAppSecret = false;
        this.inputFileId = 'applicationIconFile';
    }

    enableApiAccess() {
        this.Loader.show();
        this.processing = true;

        this.Loader.show();

        this.$timeout(() => {
            this.DeveloperApi.getListOfApps().then((data) => {
                this.developer.apps = data.applications || [];
                this.Loader.hide();
                this.processing = false;
                this.developer.access = true;
            });
        }, 1000);
    }

    select(item) {
        this.currentApp = _cloneDeep(item);
        this.currentAppId = item.id;
        this.showAppSecret = false;
    }

    create(ev) {
        // TODO: should be implement after update real API
        this.DialogService.show({
            controller: createAppDialogController,
            controllerAs: '$ctrl',
            template: createAppTemplate,
            parent: document.body,
            targetEvent: ev,
            openFrom: 'top',
            closeTo: 'top',
            clickOutsideToClose: true,
            escapeToClose: true,
            fullscreen: true,
            locals: {
                apps: this.developer.apps
            }
        });
    }

    toggleAppSecret() {
        this.showAppSecret = !this.showAppSecret;
    }

    showUpload() {
        // TODO: should be implement after update real API
        document.querySelector(`#${this.inputFileId}`).click();
    }

    regenerateKey() {
        this.DialogService.confirm({
            title: 'Regenerate Key?',
            textContent: 'Do you really want to change key?',
            ariaLabel: 'regenerate-key',
            ok: 'Ok',
            cancel: 'Cancel'
        }).then(() => {
            // TODO: refactor to API usage, mock for now
            this.developer.key = 'as988d8as7d8hjak--zx89jiaojd9';
        });
    }

    regenerateSecretKey() {
        this.DialogService.confirm({
            title: 'Regenerate Secret Key?',
            textContent: 'Do you really want to change secret key?',
            ariaLabel: 'regenerate-secret-key',
            ok: 'Ok',
            cancel: 'Cancel'
        }).then(() => {
            // TODO: refactor to API usage, mock for now
            this.currentApp.secret = Math.floor(Math.random() * 1000000000000000000);
        });
    }

    remove() {
        this.DialogService.confirm({
            title: 'Delete Application?',
            textContent: `Do you really want to delete application "${this.currentApp.name}"?`,
            ariaLabel: 'delete-app',
            ok: 'Delete',
            cancel: 'Cancel'
        }).then(() => {
            this.developer.apps = this.developer.apps.filter(item => item.id !== this.currentAppId);
            this.cancel();
        });
    }

    cancel() {
        this.currentApp = null;
        this.currentAppId = null;
    }

    save() {
        // TODO: should be implementing with real api
        this.Loader.show();

        this.DeveloperApi.update(this.currentApp).then((data) => {
            this.developer.apps.forEach((item) => {
                if (item.id === data.id) {
                    item.name = data.name;
                    item.description = data.description;
                }
            });

            this.Loader.hide();
            this.ToastService.show(this.ToastService.createSimple({
                text: 'App updated',
                position: 'bottom right'
            }));
        });
    }
}



// WEBPACK FOOTER //
// ./app/components/developer-settings/api-access/api-access.controller.js